const initialState = {
  offline: false,
}

export const network = (state = initialState, action) => {
  switch (action.type) {
    case 'OFFLINE':
      return Object.assign({}, state, {
        offline: true,
      })
    case 'ONLINE':
      return Object.assign({}, state, {
        offline: false,
      })

    default:
      return state
  }
}

export default network
